import { AfterViewInit, Component, ElementRef, NgZone, OnDestroy } from "@angular/core";

import { TranslateService } from "@ngx-translate/core";
import { SystemConfigPromiseService } from "shared/cubiq-services";
import { BfxBaseBlotterColumnSelectorService } from "../../bfx-base-blotter/bfx-base-blotter-columnselector.service";

import { BfxMouseModifierKeyService } from "app/bfx-common/services/bfx-mouse-modifier-key.service";

// import LoggerService from "@bfx/logger";
/// const logger = LoggerService.for(__dirname);

import { BfxFwdRollBaseBlotterComponent } from "app/bfx-blotter-intervention/fwd-roll-pricing/bfx-fwd-roll-base-blotter";
import { FwdRollCurrencyTableDefinitionFactory } from "shared/cubiq-services/model/FwdRollCurrencyTableDefinitionFactory";
import { FwdRollRowType } from "shared/cubiq-model-multi-asset";

@Component({
  selector: "bfx-fwd-roll-currencies-grid",
  templateUrl: "./html/bfx-fwd-roll-orders-grid.html",
  standalone: false,
})
export class BfxFwdRollCurrenciesBlotterComponent
  extends BfxFwdRollBaseBlotterComponent
  implements OnDestroy, AfterViewInit
{
  constructor(
    BfxBlotterElement: ElementRef,
    tableDefinitionFactory: FwdRollCurrencyTableDefinitionFactory,
    translationService: TranslateService,
    columnSelectorService: BfxBaseBlotterColumnSelectorService,
    sysConfigService: SystemConfigPromiseService,
    mouseModifierKeyService: BfxMouseModifierKeyService,
    zone: NgZone,
  ) {
    super(
      BfxBlotterElement,
      tableDefinitionFactory,
      translationService,
      columnSelectorService,
      sysConfigService,
      mouseModifierKeyService,
      zone,
    );
  }

  /**
   * Datamodel is taken from the portfoliomodel currenciesData
   * @returns
   */
  protected override getGridDataModel() {
    return this.portfolioModel.currenciesData;
  }

  public override getRowType(): FwdRollRowType {
    return FwdRollRowType.CURRENCY;
  }
}
